<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-container-single element-type-preface element-with-heading" id="preface">
<div class="heading heading-with-title heading-without-image" id="preface-heading">
<div class="heading-contents">
<div class="title-subtitle-block title-block-without-element-number">
<div class="element-number-block">
</div>
<div class="title-block">
<h1 class="title">Preface</h1>
</div>
</div>
</div>
</div>
<div class="text" id="preface-text">
<p class="first first-in-chapter first-full-width"><i><span class="first-phrase"><span class="drop-cap"><span class="first-punctuation">‘</span>I</span>t is</span> a coroner’s statutory duty to hold inquests when there is reasonable cause to suspect a violent or unnatural death; but a coroner cannot act unless he is <span class="last-word">informed</span>.’</i></p>
<div class="alignment-block alignment-block-align-right">
<p class="alignment-block-content alignment-block-content-right"><sup>John Troutbeck, Westminster <span class="last-word">and</span></sup></p>
<p class="alignment-block-content alignment-block-content-right"><sup>South-Western London <span class="last-word">Coroner</span></sup></p>
<p class="alignment-block-content alignment-block-content-right"><sup>(letter to </sup><i><sup>The Times</sup></i><sup> June 10th <span class="last-word">1908</span>)</sup></p>
</div>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// preface.vue?3163f1ae